export default "__VITE_ASSET__BTa0i3IU__"